import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { isProduction } from '@/components/signup/utils/environment';
import { Button } from '@/libraries/design/components/button/src/button';

/**
 * Shown when none of the user's JPD sites are in an org they administer, so there is no site they
 * can switch to Product Collection from here.
 */
export const ProductCollectionSwitchYourSiteMessage = () => (
	<>
		<p css={contentCss}>
			<FormattedMessage
				id="signup.productCollection.switchYourSite"
				defaultMessage="Admins can add Product Collection to an existing site from Atlassian Administration."
			/>
		</p>
		<Button
			variant="primary"
			css={buttonCss}
			href={isProduction() ? 'https://home.atlassian.com' : 'https://home.stg.atlassian.com'}
			target="_self"
		>
			<FormattedMessage
				id="signup.productCollection.switchYourSite.button"
				defaultMessage="Back to Home"
			/>
		</Button>
	</>
);

const contentCss = css({
	textAlign: 'center',
	marginBlockEnd: 36,
});

const buttonCss = css({
	maxWidth: 'none',
});
